/** @jsx jsx */
import {jsx} from '@emotion/core'

const InlineErrorMessage = ({message}: any) => {
  return <div className="errorMessage">{message}</div>
}

export default InlineErrorMessage
